export const formatMoney = (number) => {
  return number?.toLocaleString("es-AR", {
    style: "currency",
    currency: "ARS",
  });
};
